import { ResponseError } from '@roadfootage/api-client'

// The API explains why it refused a request (too far, already claimed, not enough points) in the body:
// plain text, a JSON string, or problem details. Show that text rather than a generic failure.
export async function readApiErrorMessage(error: unknown, fallback: string): Promise<string> {
  if (!(error instanceof ResponseError)) return fallback
  let body: string
  try {
    body = (await error.response.text()).trim()
  } catch {
    return fallback
  }
  if (!body) return fallback
  try {
    const parsed = JSON.parse(body)
    if (typeof parsed === 'string') return parsed || fallback
    return parsed?.detail ?? parsed?.title ?? fallback
  } catch {
    return body
  }
}
